<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<h1 class="Heading-1" id="_idParaDest-1" xml:lang="en-US"><a id="_idTextAnchor000"></a>The Life Drawing Club</h1>
<p class="Verse-first">The three of us were mates</p>
<p class="Verse-main">Have been for many years.</p>
<p class="Verse-main">So, when asked to pose for model’s rates,</p>
<p class="Verse-main">We took the money and the jeers.</p>
<p class="Verse-new">The evening arrived all too soon</p>
<p class="Verse-main">We chose the clothes we would model with care.</p>
<p class="Verse-main">We all assembled in a tiny room</p>
<p class="Verse-main">And were told, ‘No clothes, you’ll all be bare.’</p>
<p class="Verse-new">‘Bare!’ we shrieked. ‘What, in the nude? That never was the deal.’</p>
<p class="Verse-main">But the lady in charge said,</p>
<p class="Verse-main">‘Get them off and I’m not being crude.</p>
<p class="Verse-main">This is life drawing; we all know how you feel.’</p>
<p class="Verse-new">We posed two hours, with our butts on display</p>
<p class="Verse-main">Too nervous to show all we’d got.</p>
<p class="Verse-main">Then someone shouted,</p>
<p class="Verse-main">‘Turn them around the other way.’</p>
<p class="Verse-main">‘My God, you all look pretty hot.’</p>
<p class="Verse-new">The evening was a roaring success</p>
<p class="Verse-main">And we were all asked to ‘Come next week’.</p>
<p class="Verse-main">We looked at each other but no one said yes.</p>
<p class="Verse-main">It was NOT a job for the quiet or the meek.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781398418653_EPUB-4.vue?58674aa5